import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import MatchingQueue from './pages/MatchingQueue';
import SessionRoom from './pages/SessionRoom';
import Appointments from './pages/Appointments';
// import SessionHistory from './pages/SessionHistory';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';

// Components
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import RootRedirect from './components/RootRedirect';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SocketProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected routes */}
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/resend-verification" element={<ResendVerification />} />
                <Route path="/profile/:userId" element={<Profile />} />
                <Route path="/profile/edit" element={<EditProfile />} />
                <Route path="/matching" element={<MatchingQueue />} />
                <Route path="/session/:sessionId" element={<SessionRoom />} />
                {/* <Route path="/history" element={<SessionHistory />} /> */}
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              </Route>
            </Route>

            {/* Smart root routing - landing page for non-auth, dashboard for auth */}
            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
